<template>
    <div class="student-box">
        <div class="student-box-bg">
            <div class="student-box-title">
                <img src="@/assets/images/submit_students_img2.png" class="student-img2">
                <img src="@/assets/images/submit_students_img1.png">
            </div>
            <div class="student-box-common desc-view">
                <h3>
                    导言
                    <span>INTRODUCTION</span>
                </h3>
                <p>
                    近期，教育部印发通知，对做好2023年普通高校部分特殊类型考试招生工作作出部署，高校招收保送生即将开始。今年，奥赛集训队成员将重点安排在基础学科相关专业；外语类保送生继续加大向国家“一带一路”建设发展所需语种专业及国家急需紧缺语种专业倾斜力度……哪些考生还有保送资格？保送生录取有哪些程序？一起来看看吧。
                </p>
            </div>
        </div>
        <el-row class="student-box-common new-view">
            <el-col :span="8" @click.native="gotoPath('/newsDetail', '66')">
                <div>
                    <button>2023年</button>
                    <h2>普通高等学校部分特殊类型招生基本要求</h2>
                    <div>查看详情<i class="el-icon-arrow-right"></i></div>
                </div>
            </el-col>
            <el-col :span="16">
                <div>
                    <h3>
                        招生动态
                        <span>ENROLLMENT DYNAMICS</span>
                        <button v-if="total > 0" @click="gotoPath('/recommendNews')">查看全部<i class="el-icon-arrow-right"></i></button>
                    </h3>
                    <div class="no-data-box" v-if="total === 0">
                        <img src="../../assets/images/null.png" alt="没有数据">
                        <p>暂无数据</p>
                    </div>
                    <div v-else-if="total > 0" v-for="(item, index) in news_list" class="new-item" @click="gotoPath('/recommendNewsDetail', item.id)">{{ item.news_title }}</div>
                </div>
            </el-col>
        </el-row>
        <div class="tiao-view">
            <div class="student-box-common">
                <h2>哪些考生具有保送资格</h2>
                <el-row :gutter="20">
                    <el-col v-for="(item, index) in tiao_list" :key="index" :span="6">
                        <div>
                            <div>
                                <img :src="item.src">
                            </div>
                            <h4>{{ item.title }}</h4>
                        </div>
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="tips-view">
            <div class="student-box-common">
                <h2>保送生录取程序</h2>
                <p>注：已确认保送录取的学生不再参加普通高校招生全国统一录取</p>
                <el-row>
                    <el-col v-for="(item, index) in tips_list" :key="index" :span="6">
                        <div>
                            <div>{{ index + 1}}</div>
                            <h4>{{ item.title }}</h4>
                        </div>
                        <img v-if="index < tips_list.length - 1" src="../../assets/images/submit_students_arrow.png">
                    </el-col>
                </el-row>
            </div>
        </div>
        <div class="student-box-common school-view">
            <h2>2023年全国高校保送生招生简章汇总</h2>
            <p>由于各方面条件不断调整变化，请考生以各学校公布的最新消息为准</p>
            <div class="pro-view">
                <a>省份：</a>
                <a v-for="(item, index) in province_list" :key="index" :class="index === active_index ? 'active-tag' : ''" @click="changePro(item.provinceid, index)">{{ item.name }}</a>
            </div>
            <div class="no-data-box" v-if="scl_total === 0">
                <img src="../../assets/images/null.png" alt="没有数据">
                <p>暂无数据</p>
            </div>
            <template v-else-if="scl_total > 0" v-for="(item, index) in paginate_data">
                <h3>{{ province_obj[index] }}</h3>
                <el-table :data="item" style="width: 100%" border class="table-view" :span-method="objectSpanMethod" >
                    <el-table-column label="院校" prop="scl_name" min-width="150" show-overflow-tooltip />
                    <el-table-column label="类别">
                        <template slot-scope="scope">
                            <div @click="gotoPath('/recommendPolicyDetail', scope.row.id)" class="recommend-type-view">
                                {{ scope.row.recommend_type.dic_value }}
                            </div>
                        </template>
                    </el-table-column>
                    <el-table-column label="报名条件" prop="apply_condition" min-width="130" show-overflow-tooltip />
                    <el-table-column label="考核方式" prop="evaluation_mode" min-width="120" show-overflow-tooltip />
                    <el-table-column label="流程及安排" prop="process_plan" min-width="140" show-overflow-tooltip/>
                    <el-table-column label="录取规则" prop="admission_rule" min-width="150" show-overflow-tooltip />
                    <el-table-column label="招生简章">
                        <template slot-scope="scope">
                            <div @click="gotoPath('/recommendPolicyDetail', scope.row.id)" class="recommend-type-view">查看</div>
                        </template>
                    </el-table-column>
                </el-table>
            </template>
        </div>
    </div>
</template>

<script>
import { getPolicyList, getNewsList } from '@/api/submit_students'
import { getSearchDic } from '@/api/zhiyuan'
import { mapState } from 'vuex'

export default {
    data() {
        return {
            tips_list: [
                { title:'考生提出保送申请' },
                { title:'审核公示参加考核' },
                { title:'高校公示' },
                { title:'办理录取手续' }
            ],
            tiao_list: [
                { src: require('../../assets/images/submit_students_img4.png'), title:'中学生学科奥林匹克竞争赛国家集训队成员' },
                { src: require('../../assets/images/submit_students_img5.png'), title:'部分外国语中学推荐的优秀学生' },
                { src: require('../../assets/images/submit_students_img6.png'), title:'公安英烈子女' },
                { src: require('../../assets/images/submit_students_img7.png'), title:'退役运动员' }
            ],
            paginate_data: {},
            news_list: [],
            active_pro: '',
            active_index: 0,
            province_list: [
                {name : "全部"},
            ],
            province_obj: {},
            total: -1,
            pos: 0,
            scl_list: {},
            scl_total: -1
        };
    },
    watch: {
    },

    mounted() {
        this.getSearchDicHandler()
        setTimeout(()=>{
            this.getPolicyList()
            this.getNewsList()
        }, 200)
    },

    methods: {
        getSearchDicHandler() {
            getSearchDic().then(res => {
                this.province_list.push(...res.data.province);
                res.data.province.map(item => {
                    this.province_obj[item.provinceid] = item.name
                })
            })
        },
        getPolicyList() {
            getPolicyList(this.active_pro).then(res => {
                this.paginate_data = res.data
                if(Object.keys(this.paginate_data).length > 0) {
                    this.scl_total = 1
                } else {
                    this.scl_total = 0
                }
                for (const key in this.paginate_data) {
                    if (Object.hasOwnProperty.call(this.paginate_data, key)) {
                        const element = this.paginate_data[key]
                        this.scl_list[key] = []
                        element.map((item1, index1) => {
                            if (index1 === 0) {
                                this.scl_list[key].push(1)
                                this.pos = 0
                            } else { 
                                if (item1.scl_id === element[index1 - 1].scl_id) {
                                    this.scl_list[key][this.pos] += 1
                                    this.scl_list[key].push(0)
                                } else {
                                    this.scl_list[key].push(1)
                                        this.pos = index1
                                }
                            }
                        })
                    }
                }
            })
        },
        getNewsList() {
            getNewsList(1, 4).then(res => {
                this.news_list = res.data.data
                this.total = res.data.total
            })
        },
        changePro(provinceid, index) {
            this.active_index = index
            if(index === 0) {
                this.active_pro = ''
            } else {
                this.active_pro = provinceid
            }
            this.scl_total = -1
            this.getPolicyList()
        },
        gotoPath(path, id) {
            this.$router.push({
                path: path,
                query: {
                    id: id
                }
            })
        },
        objectSpanMethod({ row, column, rowIndex, columnIndex }) {
            if (columnIndex === 0) {
                let _row = this.scl_list[row.province_id][rowIndex]
                let _col = this.scl_list[row.province_id][rowIndex] > 0 ? 1 : 0
                return {
                    rowspan: _row,
                    colspan: _col,
                }
            }
        }
    },
};
</script>

<style lang="scss" scoped>
@import '@/assets/css/variables.scss';
$width: 1200px;
$margin: 0 auto;
.student-box {
	margin-bottom: -56px;
    background: #ffffff;
}
.student-box-bg {
    background: url('../../assets/images/submit_students_bg.png') no-repeat;
    background-size: cover;
    // height: 881px;
    .student-img2 {
        margin-top: 25px;
        height: 230px;
    }
    .student-box-title {
        width: 1184px;
        margin: 0 auto;
        position: relative;
        padding-top: 75px;
        display: flex;
        justify-content: space-between;
    }
    .desc-view {
        background: rgba(255,255,255,0.80);
        border: 1px solid #ffffff;
        border-radius: 20px;
        box-shadow: 0px 4px 16px 0px rgba(0,70,182,0.04); 
        backdrop-filter: blur(4px);
        padding: 24px;
        box-sizing: border-box;
        margin-bottom: 40px;
        margin-top: -20px;
        p {
            font-size: 16px;
            color: #332e2c;
            line-height: 28px;
            text-align: left;
        }
    }
}
h3 {
    font-size: 22px;
    color: #292d33; 
    margin: 0;
    span {
        font-size: 16px;
        color: #ccc6c4;
        line-height: 22px;
        font-weight: 400;
    }
}
h3:before {
    content: ''; 
    display: inline-block;
    width: 3px;
    height: 20px;
    background: #3f89ff;
    border-radius: 1px;
    position: relative;
    top: 2px;
    margin-right: 8px;
}
.student-box-common {
    width: $width;
    margin: $margin;
    padding: 64px 0 88px 0;
    h2 {
        font-size: 32px;
        color: #292d33;
        line-height: 45px;
        text-align: center;
        margin: 0 0 16px 0;
    }
    p {
        font-size: 14px;
        color: #c5cad1;
        line-height: 20px;
        text-align: center;
        margin-bottom: 40px;
    }
}
.new-view {
    padding-bottom: 80px;
    .el-col-8 {
        > div {
            background: url('../../assets/images/submit_students_img3.png') no-repeat;
            height: 271px;
            width: calc(100% - 20px);
            background-size: cover;
            border-radius: 20px;
            padding: 32px;
            box-sizing: border-box;
            cursor: pointer;
            button {
                background: #ffe8a6!important;
                border-radius: 24px;
                border: none;
                padding: 7px 16px;
                font-size: 24px;
                color: #ff7721;
                line-height: 34px;
            }
            h2 {
                width: 90%;
                margin: 14px 0 37px 0;
                font-size: 28px;
                color: #ffffff;
                line-height: 42px;
                text-shadow: 0px 2px 0px 0px rgba(145,39,0,0.26); 
                text-align: left;
            }
            div {
                color: #ffffff;
                font-size: 16px;
                i {
                    margin-left: 4px;
                }
            }
        }
    }
    .el-col-16 {
        > div {
            height: 271px;
            background: linear-gradient(135deg,#f5f9ff 2%, #edf4ff);
            border: 1px solid #e4ecf7;
            border-radius: 20px;
            backdrop-filter: blur(4px);
            padding: 24px;
            box-sizing: border-box;
            position: relative;
            button {
                border: 1px solid #ccc6c4;
                border-radius: 8px;
                font-size: 14px;
                color: #999390;
                line-height: 20px;
                padding: 5px 10px;
                float: right;
                i {
                    margin-left: 4px;
                }
            }
            .new-item {
                font-size: 16px;
                color: #2c2e33;
                line-height: 22px;
                margin-top: 24px;
                cursor: pointer;
            }
            .new-item:hover {
                color: #3f89ff;
            }
        }
    }
}
.tiao-view {
    background: #f7f9fc;
    .el-col {
        margin-top: 24px;
        > div {
            background: #ffffff;
            border: 1px solid #ebeef4;
            border-radius: 20px;
            display: flex;
            height: 120px;
            align-items: center;
            padding: 24px;
            box-sizing: border-box;
            > div {
                flex: 0 0 72px;
                height: 72px;
                background: linear-gradient(180deg,#f5f9ff, #f2f7ff 98%);
                border: 1px solid #ebeef4;
                border-radius: 8px;
                display: flex;
                align-items: center;
                justify-content: center;
                margin-right: 16px;
            }
            h4 {
                font-size: 16px;
                color: #332e2c;
                line-height: 24px;
            }
        }
    }
}
.tips-view {
    background: url('../../assets/images/submit_students_img8.png') no-repeat;
    height: 355px;
    background-size: cover;
    .student-box-common {
        width: 1270px;
    }
    h2 {
        color: #fff;
    }
    .el-col-6 {
        display: flex;
        align-items: center;
        img {
            position: relative;
            left: 65px;
        }
        > div {
            background: url('../../assets/images/submit_students_img9.png') no-repeat;
            background-size: cover;
            height: 82px;
            flex: 0 0 calc(100% - 86px);
            display: flex;
            align-items: center;
            position: relative;
            padding-left: 40px;
            box-sizing: border-box;
            color: #ffffff;
            line-height: 26px;
            font-size: 18px;
            left: 50px;
            > div {
                color: #fff;
                font-size: 26px;
                font-weight: 700;
                font-style: italic;
                width: 48px;
                height: 48px;
                text-align: center;
                line-height: 48px;
                padding-right: 5px;
                box-sizing: border-box;
                background: linear-gradient(135deg,#51b2ff, #3f89ff);
                border-radius: 12px;
                box-shadow: 0px 2px 4px 0px rgba(67,146,255,0.36); 
                position: absolute;
                left: -20px;
            } 
        }
    }
}
.school-view {
    min-height: 520px;
    .no-data-box {
        position: relative;
        text-align: center;
        margin-top: 150px;
    }
    p {
        color: #909399;
    }
    .pro-view {
        a:first-child {
            color: #909399;
            margin: 0;
        }
        a {
            display: inline-block;
            font-size: 14px;
            line-height: 20px;
            color: #5e6166;
            margin: 0 19px 12px 0;
            padding: 1px 5px;
            text-align: center;
            cursor: pointer;
        }
        .active-tag {
            color: #ffffff;
            background: #3f89ff;
            border-radius: 4px;
        }
    }
    h3 {
        margin-top: 30px;
    }
}
::v-deep .table-view {
    margin-top: 16px;
    th {
        background: #f0f2f5;
        color: #2c2e33;
    }
}
.no-data-box {
    position: absolute;
    top: 70%;
    left: 50%;
    transform: translate(-50%, -50%);
    img {
        width: 110px;
        height: 110px;
    }
    p {
        font-size: 16px;
        text-align: center;
        color: #666666;
        margin-left: - 12px;
        margin-top: 0px;
    }
}
.recommend-type-view {
    color: #3f89ff;
    cursor: pointer;
}
</style>